export default __webpack_public_path__ + "media/zurb/img/blog/blogpost-screenshot1-5eaa20b21872365bca20a3dc8ef8538b.png";